import { ListeTable } from '@mairistem/liste';
import dayjs from 'dayjs';
import _ from 'lodash';
import React from 'react';
import { RegieContext } from '@/contexts';
import type { FactureImpayeeListeItemType } from '@/types';
import { formatMonetaire } from '@/utils';

interface FacturesImpayeesListeTableRowProps {
  item: FactureImpayeeListeItemType;
  rowProps: Record<string, unknown>;
}

const FacturesImpayeesListeTableRow = (props: FacturesImpayeesListeTableRowProps) => {
  const { item, rowProps } = props;

  const { regies, selectedRegie } = React.useContext(RegieContext);
  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn =
    _.size(_.find(regies, { identifiant: selectedRegie })?.logicielsFacturier) <= 1;

  const { identifiant, numero, nomPayeur, source, dateEmission, dateLimite, montant, resteAPayer } =
    item;

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="numero"
        // @ts-expect-error
        title={numero}
        style={{ width: 175 }}
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {numero}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="nomPayeur"
        // @ts-expect-error
        title={nomPayeur}
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {nomPayeur}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell name="dateEmission" textAlign="center" style={{ width: 150 }}>
        {dayjs(dateEmission).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      <ListeTable.Cell name="dateLimite" textAlign="center" style={{ width: 150 }}>
        {dayjs(dateLimite).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      {!hideSourceColumn && (
        <ListeTable.Cell name="source" textAlign="center" style={{ width: 90 }}>
          {source}
        </ListeTable.Cell>
      )}
      <ListeTable.Cell name="montant" textAlign="right" style={{ width: 130 }}>
        {formatMonetaire(montant)}
      </ListeTable.Cell>
      <ListeTable.Cell name="resteAPayer" textAlign="right" style={{ width: 130 }}>
        {formatMonetaire(resteAPayer)}
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default FacturesImpayeesListeTableRow;
